export class DownloadFile {
  constructor() {
    this.label = undefined;
    this.size = undefined;
    this.url = undefined;
    this.format = undefined;
  }
  static get is() { return "gl-download-file"; }
  static get properties() {
    return {
      "label": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Human-readable name of the file."
        },
        "attribute": "label",
        "reflect": false
      },
      "size": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Human-readable file size (e.g., 2.5 MB)."
        },
        "attribute": "size",
        "reflect": false
      },
      "url": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "URL of the file."
        },
        "attribute": "url",
        "reflect": false
      },
      "format": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "File format (e.g., PDF)."
        },
        "attribute": "format",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=download-file.js.map
